import { graphql } from "~/gql";

export const CREATE_AND_ADD_DISBURSEMENT = graphql(/* GraphQL */ `
  mutation createAndAddDisbursement($data: DisbursementCreateInput!) {
    createAndAddDisbursement(data: $data) {
      ...DisbursementParts
    }
  }
`);
